import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import audicusLogo from '../assets/images/audicus-logo.png';

const Header = () => {
  const { pathname } = useLocation();
  const { i18n } = useTranslation('home');

  const toggleLanguage = () => {
    const newLanguage = i18n.language === 'en' ? 'es' : 'en';
    i18n.changeLanguage(newLanguage);
  };

  if (pathname !== '/') {
    return (
      <div className="header">
        <img src={audicusLogo} alt="audicus logo" />

        <div className="language-button">
          <button onClick={toggleLanguage}>
            {i18n.language === 'en' ? 'Español' : 'English'}
          </button>
        </div>
      </div>
    );
  } else {
    return <></>;
  }
};

export default Header;
